// @flow

type Options = {
  approximatelyText: string,
  deliveryTime: number,
  deliveryTimeText: string,
  timeUnitSingle: string,
  timeUnitPlural: string,
};

export default ({
  approximatelyText,
  deliveryTime,
  deliveryTimeText,
  timeUnitSingle,
  timeUnitPlural,
}: Options): string => {
  const timeIndicator = deliveryTime === 1 ? timeUnitSingle : timeUnitPlural;
  return [deliveryTimeText, approximatelyText, deliveryTime.toString(), timeIndicator]
    .filter(string => typeof string === 'string')
    .join(' ');
};
